export function noop() { }

export function noopWithWarn(message: string) {
  return () => {
    console.warn(message);
  };
}

// Used to verify ensure exhaustive check through all cases in switch
export function assertUnreachable(_x: never): never {
  throw new Error("Unreachable");
}
